export const orderTypes = {
    ASC: 'ASC',
    DESC: 'DESC',
}


// WEBPACK FOOTER //
// ./src/constants/db.js